import Vue from 'vue';
import axios from 'axios';
import conf from "./config";
import { isUrl } from "./tool"
import {getToken} from "./storage";
import auth from "./auth";

// const openApi = ['/official/auth', '/official/jssdk'];

axios.interceptors.request.use(config => {
  let token = getToken();
  // if(openApi.indexOf(config.url) == -1 && !token) {
  //   auth();
  // }
  if (!isUrl(config.url)) {
    config.url = conf.host + config.url;
  }
  let headers = {'Content-Type': 'application/json'};
  token && (headers["Authorization"] = 'Bearer ' + token.token);
  config.headers = Object.assign(config.headers, headers);
  config.loadingText !== false && Vue.$showLoading(config.loadingText);
  return config;
}, err => {
  Vue.$toast('请求超时');
  return Promise.reject(err);
});
axios.interceptors.response.use(res => {
  res?.config?.loadingText !== false && Vue.$hideLoading();
  let status = res.status;
  if (status && /20[0-9]/.test(status + '')) {
    return res.data;
  }  else {
    return Promise.reject(res);
  }
}, err => {
  err?.config?.loadingText !== false && Vue.$hideLoading();
  if(axios.isCancel(err)) {
    console.log('Request canceled.');
  } else if(err.response) {
    let status = err.response.status;
    if(status == 401) {
      auth();
    } else if(err.response && err.response.data && err.response.data.message) {
      Vue.$toast(err.response.data.message);
    } else if(/4[0-9][0-9]/.test(status + '')) {
      Vue.$toast('请求不到资源');
    } else if(/5[0-9][0-9]/.test(status + '')) {
      Vue.$toast('服务器开小差了');
    } else {
      Vue.$toast('系统繁忙');
    }
  } else {
    Vue.$toast('系统繁忙');
  }
  return Promise.reject(err);
});

export default axios;
